import apiClient from '@/services/axios'

export async function put(dto) {
  var response = await apiClient.put('/PersonalTodos/Order', dto)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update todo order')
}